require('./bootstrap');

require('alpinejs');

require('datatables.net');
require('datatables.net-bs5');
require('datatables.net-buttons-bs5');

require('./common');
require('./grid');
require('./api-events');
require('./sidebar');
require('./forms');
